import { PrivacyPolicyDataAdapter } from '@/base/domains';
import { Optional } from '@/base/types';

export class InMemoryPrivacyPolicyDataAdapter implements PrivacyPolicyDataAdapter {
  findPrivacyPolicyVersion(): Promise<Optional<string>> {
    return Promise.resolve(undefined);
  }
}
